import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function GetTournament(tournamentId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + tournamentId, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch tournaments.' },
      { status: 500 }
    ));
  }

  const resData = await response.json();
  return resData.data;
}

export async function ListTournaments(page, admin) {
  const token = getAuthToken()
  const pathUrl = admin ? `/rest/admin/tournaments` : `/rest/tournaments`

  if (token === null) {
    return { data: [], pagination: {} }
  }

  const url = config.apiBaseUrl + pathUrl + (page ? `?page=${page}` : '')
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch groups.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function GetTournamentInfo(tournamentId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/tournaments/' + tournamentId, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch tournament info.' },
      { status: 500 }
    ));
  }

  return { status: response.status, ...(await response.json()) };
}


export async function GetTournamentInfoMatches(tournamentId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/tournaments/' + tournamentId + '/matches', {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch tournament matches.' },
      { status: 500 }
    ));
  }

  return { status: response.status, ...(await response.json()) };
}

export async function ListTournamentsAdmin(page) {
  return await ListTournaments(page, 1)
}

export async function CreateTournament(tournament) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({ tournament: tournament })
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function UpdateTournament(id, tournament) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + id, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({ tournament: tournament })
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function DeleteTournament(id) {
  const response = await fetch(config.apiBaseUrl + `/rest/admin/tournaments/${id}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (!response.ok) {
    return false;
  } else {
    return true;
  }
}

export async function ListTeamRecentMatchesHistoryByTournament(tournamentId, teamId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/tournaments/' + tournamentId + '/teams/' + teamId + '/recent_matches_history', {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status >= 500) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return { status: response.status, ...(await response.json()) };
}